import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { type TaskTemplateListType } from '@repo/crm-atoms';
import { translate, TranslationEntity } from '@repo/utils';
import {
  Button, Col, Flex, Row, Select, Typography,
} from 'antd';
import React from 'react';

import ComparatorRenderer from '../ComparatorRenderer';
import styles from './TaskBaseCreateMenu.module.scss';

interface TaskTemplateSelectionProps {
  selectedTaskTemplates: { taskTemplateId: number }[];
  taskTemplatesData?: TaskTemplateListType;
  updateExistingField: (field: { taskTemplateId: number }, index: number) => void;
  deleteField: (index: number) => void;
  addNewDefaultField: () => void;
}

export default function TaskTemplateSelection({
  selectedTaskTemplates,
  taskTemplatesData,
  updateExistingField,
  deleteField,
  addNewDefaultField,
}: TaskTemplateSelectionProps) {
  return (
    <>
      <Flex gap={8} vertical>
        {selectedTaskTemplates.map((template, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <React.Fragment key={index}>
            <Flex gap={8}>
              <Row className={styles.changedAttributes}>
                <Col span={6}>
                  {index === 0 && (
                    <Typography.Text strong>
                      {translate(
                        `#{${TranslationEntity.task}} Template is `,
                        [{ capitalize: true }],
                      )}
                    </Typography.Text>
                  )}
                </Col>
                <Col span={12}>
                  <Select
                    value={taskTemplatesData?.taskTemplates.find(
                      (_template) => _template.id === template.taskTemplateId.toString(),
                    )?.id}
                    options={taskTemplatesData?.taskTemplates.map((t) => ({
                      value: t.id,
                      label: t.name,
                    }))}
                    className={styles.select}
                    onChange={(value) => updateExistingField({ taskTemplateId: parseInt(value, 10) }, index)}
                    showSearch
                    optionFilterProp="label"
                  />
                  {index !== 0 && (
                    <Button
                      type="link"
                      onClick={() => deleteField(index)}
                      icon={<DeleteOutlined />}
                      danger
                    >
                      Remove
                    </Button>
                  )}
                </Col>
              </Row>
            </Flex>
            {index !== selectedTaskTemplates.length - 1 && (
              <Row>
                <Col span={15}>
                  <ComparatorRenderer
                    comparator="or"
                    className={styles.comparator}
                  />
                </Col>
              </Row>
            )}
          </React.Fragment>
        ))}
      </Flex>
      <Row>
        <Col span={6} />
        <Col span={14} className={styles.addBtnContainer}>
          <Button
            onClick={addNewDefaultField}
            type="dashed"
            icon={<PlusOutlined />}
            className={styles.addBtn}
          >
            {translate(
              `Add New #{${TranslationEntity.task}} Template`,
              [{ capitalize: true }],
            )}
          </Button>
        </Col>
      </Row>
    </>
  );
}
